// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_wrap__zGG8w {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  background: var(--dylo-field-bg);
  border: 1px solid var(--dylo-field-border);
  border-radius: var(--radius-control);
  padding: 0 14px;
  height: 46px;
  box-shadow: var(--shadow-control);
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.Input_wrap__zGG8w:focus-within {
  border-color: var(--dylo-teal-500);
  box-shadow: 0 0 0 3px rgba(24, 162, 156, 0.15);
}

.Input_wrap__zGG8w.Input_invalid__EfvhD {
  border-color: var(--dylo-danger);
}
.Input_wrap__zGG8w.Input_invalid__EfvhD:focus-within {
  box-shadow: 0 0 0 3px rgba(229, 72, 77, 0.15);
}

.Input_icon__2NIri {
  display: inline-flex;
  color: var(--dylo-field-icon);
  flex-shrink: 0;
}

.Input_input__ke9Mv {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--font-sans);
  font-size: 15px;
  color: var(--dylo-ink);
  height: 100%;
  min-width: 0;
}

.Input_input__ke9Mv::placeholder {
  color: var(--dylo-muted);
}

.Input_suffix__V5fkl {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--dylo-field-icon);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  flex-shrink: 0;
}
.Input_suffix__V5fkl:hover {
  color: var(--dylo-text);
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/Input/Input.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,0CAA0C;EAC1C,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,0DAA0D;AAC5D;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  background: var(--dylo-field-bg);\n  border: 1px solid var(--dylo-field-border);\n  border-radius: var(--radius-control);\n  padding: 0 14px;\n  height: 46px;\n  box-shadow: var(--shadow-control);\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.wrap:focus-within {\n  border-color: var(--dylo-teal-500);\n  box-shadow: 0 0 0 3px rgba(24, 162, 156, 0.15);\n}\n\n.wrap.invalid {\n  border-color: var(--dylo-danger);\n}\n.wrap.invalid:focus-within {\n  box-shadow: 0 0 0 3px rgba(229, 72, 77, 0.15);\n}\n\n.icon {\n  display: inline-flex;\n  color: var(--dylo-field-icon);\n  flex-shrink: 0;\n}\n\n.input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: var(--font-sans);\n  font-size: 15px;\n  color: var(--dylo-ink);\n  height: 100%;\n  min-width: 0;\n}\n\n.input::placeholder {\n  color: var(--dylo-muted);\n}\n\n.suffix {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--dylo-field-icon);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  flex-shrink: 0;\n}\n.suffix:hover {\n  color: var(--dylo-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Input_wrap__zGG8w`,
	"invalid": `Input_invalid__EfvhD`,
	"icon": `Input_icon__2NIri`,
	"input": `Input_input__ke9Mv`,
	"suffix": `Input_suffix__V5fkl`
};
export default ___CSS_LOADER_EXPORT___;
